import { render, staticRenderFns } from "./SubscribeTemplateTab.vue?vue&type=template&id=c0329e44&scoped=true"
import script from "./SubscribeTemplateTab.vue?vue&type=script&lang=js"
export * from "./SubscribeTemplateTab.vue?vue&type=script&lang=js"
import style0 from "./SubscribeTemplateTab.vue?vue&type=style&index=0&id=c0329e44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0329e44",
  null
  
)

export default component.exports